import { render } from "./BlogSingleColumn.vue?vue&type=template&id=1e16663d&scoped=true"
import script from "./BlogSingleColumn.vue?vue&type=script&lang=js"
export * from "./BlogSingleColumn.vue?vue&type=script&lang=js"

import "./BlogSingleColumn.vue?vue&type=style&index=0&id=1e16663d&scoped=true&lang=scss"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e16663d"]])

export default __exports__